import React, { useState } from "react";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../PermissionsConstants";
import { SecurityTable } from "./view/SecurityTable";

interface Props {}

export const Security: React.FC<Props> = () => {
  const viewPermission = PERMISSIONS.permission_security_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <>
      {userPermissions.includes(viewPermission) ? (
        <SecurityTable viewFromOffice={false} />
      ) : (
        ""
      )}
    </>
  );
};
